import React, { useState, useRef, useEffect } from "react";
import { Link } from "@StarberryUtils";
import { Row, Col, Container, Button } from "react-bootstrap";
import ReactReadMoreReadLess from "react-read-more-read-less"
import HTMLReactParser from 'html-react-parser';
import Logo from '../../../images/dacha-logo-blue.png';
import "./GoogleReviews.scss";
import axios from "axios";


const GoogleReviews = (props) => {


  const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };

  let [reviewList, setCustomerReview] = useState([]);
  let [allReviewList, setReviews] = useState([]);
  let [isLess, setLess] = useState(false);
  let [loading, setLoading] = useState(true);
  const strapiconfig = {
    headers: {
      Authorization:
        `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }
  const getitems = async url => {
    try {
      const { data } = await axios.get(url, strapiconfig)// could be from env files 
      setLoading(false)
      const reviews = data.filter(rev => (rev.comment != null && (rev.starRating === "FIVE" || rev.starRating === "FOUR")));
      setReviews(reviews);
      setCustomerReview(reviews.slice(0, intialNumberOfReview));
    } catch (error) {
      // cache it if fail/error;
      console.error(error)
    }
  }



  let intialNumberOfReview = 10; // chunks in which review show intially and increase
  useEffect(() => {
    let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
    getitems(url);
  }, [])


  // load more function to handle click on laod more button
  const loadMore = () => {
    let primeryLength = reviewList.length;
    let newList = allReviewList.slice(
      0,
      primeryLength + intialNumberOfReview
    );
    setCustomerReview(newList);
    if (newList.length === allReviewList.length) {
      setLess(true);
    } else {
      setLess(false);
    }
  };

  const starRating = (rating) => {
    var star = [];
    for (let i = 0; i < rating; i++) {
      star.push(<i className="icon-star"></i>);
    }
    return star;
  }

  if (loading) return <div className="gql-loading-screen"><img loading="lazy" src={Logo} alt="Loading - Dacha" /><p>Loading ...</p></div>;
  return (
    <>
      {!loading && reviewList.length > 0 &&
        <div className="testimonial-block-wrapper sec-pdy-80">
          <Container>
            <Row>

              {reviewList.map((item, index) => (

                <Col md={6} lg={4} className="testimonials-item-wrap">
                  <div className="testimonial-item" key={index}>
                    <div className="rating-row">
                      {
                        starRating(wordToNumber[item.starRating])
                      }
                    </div>
                    <div className="read-more text-sm">
                      {item.comment && (
                        <ReactReadMoreReadLess
                          charLimit={115}
                          readMoreText={"More"}
                          readLessText={"Less"}
                          readMoreClassName="read-more-less--more more-content"
                          readLessClassName="read-more-less--less more-content"
                        >
                          {item.comment}
                        </ReactReadMoreReadLess>
                      )}
                    </div>
                    <div className="testimonial-info">
                      <div className="person-img">
                        <img loading="lazy" src={item.reviewer?.profilePhotoUrl} alt={`${item.reviewer?.displayName} - Dacha`} />
                      </div>
                      <div className="person-name-block">
                        <span className="person-name text-sm-bold">{item.reviewer?.displayName}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            <Row>
                {!isLess ? (
                  <div className="d-flex justify-content-center load-more-btn w-100">
                  <Button variant="outline" onClick={loadMore}>
                    Load More
                  </Button>
                </div>
                ) : null}
            </Row>
          </Container>
        </div>
      }
    </>
  );
};

export default GoogleReviews;
